import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Determines whether to render text as FormattedMessage or as literal string
 * @param  {String}  caption   The string to render
 * @param  {Boolean} isLiteral Whether or not to render as literal string
 * @returns {String|React.ReactElement} null if there is nothing to render, otherwise
 * returns what should be rendered for the caption
 */
function renderCaption(caption, isLiteral = false) {
  if (!caption) {
    return null;
  } else if (isLiteral) {
    return <span>{ caption }</span>;
  }
  return <FormattedMessage id={ caption } />;
}

export {
  renderCaption
};
